import React from "react";
import { IconButton, Box } from "@mui/material";
import RubricSearch from "./RubricSearch";
import { ReactComponent as BookIcon } from "../../assets/icons/rubric_lib.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/rubric_edit.svg";
import { useSelector } from "react-redux";
import RubricEditorSettings from "./Settings";

const Sidebar = ({
	onChangeTab = () => {},
	tab = "editor",
	onSelectRubric = () => {},
	selectedRubricId = null,
	onUpdateRubric = () => {},
	rubric,
	loadingRubric = false,
	setLoadingRubric = () => {},
}) => {
	const uid = useSelector(({ user }) => user.auth.uid);
	const sidebarButtons = [
		{
			icon: EditIcon,
			id: "editor",
		},
		{
			icon: BookIcon,
			id: "library",
		},
	];

	const handleTabChange = (tab) => {
		if (rubric?.owners?.includes?.(uid) && tab === "editor") {
			onChangeTab(tab);
		} else if (tab === "library") {
			onChangeTab(tab);
		} else if (tab === "editor") {
			alert("Please make a copy of the rubric to edit it.");
		}
	};
	return (
		<Box>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					gap: 2,
					width: "80px",
					height: "100%",
					backgroundColor: "white",
					position: "fixed",
					top: "0",
					left: "0",
					borderRight: "1px solid #EAECF0",
					pt: "84px",
				}}>
				{sidebarButtons.map((button) => (
					<IconButton
						sx={{
							backgroundColor: tab === button.id ? "#F9FAFB" : "white",
							borderRadius: "6px",
							"&:hover": {
								backgroundColor: "#F9FAFB",
							},
						}}
						onClick={() => handleTabChange(button.id)}
						key={button.id}>
						<Box
							sx={{
								"& svg path": { stroke: tab === button.id ? "" : "#667085" },
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}>
							<button.icon />
						</Box>
					</IconButton>
				))}
			</Box>
			{/**
			 *  Build an extend sidebar with settings
			 */}
			{((rubric && tab === "editor") || tab !== "editor") && tab !== "new" && (
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 2,
						width: "400px",
						height: "100%",
						backgroundColor: "white",
						position: "fixed",
						left: "80px",
						borderRight: "1px solid #EAECF0",
					}}>
					{tab === "editor" && (
						<RubricEditorSettings
							onUpdateRubric={onUpdateRubric}
							rubric={rubric}
							loadingRubric={loadingRubric}
							setLoadingRubric={setLoadingRubric}
						/>
					)}
					{tab === "library" && (
						<RubricSearch
							onSelectRubric={onSelectRubric}
							selectedRubricId={selectedRubricId}
						/>
					)}
				</Box>
			)}
		</Box>
	);
};

export default Sidebar;
